import React from 'react';

import { DespolpadorProvider } from './despolpador';
import { TerreiroProvider } from './terreiro';
import { SecadorProvider } from './secador';
import { ArmazemProvider } from './armazem';
import { BeneficioProvider } from './beneficio';
import { CooperativaDepositoProvider } from './cooperativaDeposito';
import { RebeneficioProvider } from './rebeneficio';
import { LotesProvider } from './lotes';

function RastreabilidadeProvider({ children }) {
  return (
    <LotesProvider>
      <DespolpadorProvider>
        <TerreiroProvider>
          <SecadorProvider>
            <BeneficioProvider>
              <RebeneficioProvider>
                <ArmazemProvider>
                  <CooperativaDepositoProvider>
                    {children}
                  </CooperativaDepositoProvider>
                </ArmazemProvider>
              </RebeneficioProvider>
            </BeneficioProvider>
          </SecadorProvider>
        </TerreiroProvider>
      </DespolpadorProvider>
    </LotesProvider>
  );
}

export default RastreabilidadeProvider;
